let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8d4vK")).then(() => parcelRequire('sSRsi'));